import { render, staticRenderFns } from "./CustomerInvoice.vue?vue&type=template&id=acef2afc&scoped=true&"
import script from "./CustomerInvoice.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acef2afc",
  null
  
)

export default component.exports